
export const validatePassword = (
  password,
  newPassword,
  confirmPassword,
  // Server-verified result of the current-password check. Previously this was
  // two md5 hashes compared in the browser (incident 2026-08-26).
  currentPasswordMatches,
  setNewError,
  setConfirmError,
  setCurrentError,
  t
) => {
  const trimmedPassword = password.trim();
  const trimmedNewPassword = newPassword.trim();
  const trimmedConfirmPassword = confirmPassword.trim();
  const validregex = /^\S+(?:\s*\S+)*$/;
  if (trimmedPassword === "") {
    setCurrentError(t("changePassword.error.empty"));
    return false;
  }
  if (!currentPasswordMatches) {
    setCurrentError(t("changePassword.error.cnotmatch"));
    return false;
  }
  if (confirmPassword.includes(" ")) {
    setConfirmError(t("changePassword.error.space2"));
    return false;
  }
  if (newPassword.includes(" ")) {
    setNewError(t("changePassword.error.space2"));
    return false;
  }

  if (trimmedPassword === "") {
    setCurrentError(t("changePassword.error.Fspace"));
    return false;
  }
  if (
    trimmedPassword.includes(" ") ||
    trimmedNewPassword.includes(" ") ||
    trimmedConfirmPassword.includes(" ")
  ) {
    setCurrentError(t("changePassword.error.space"));
    return false;
  }

  if (password === newPassword) {
    setNewError(t("changePassword.error.different"));
    return false;
  }

  if (trimmedPassword == "" && trimmedNewPassword == "" && trimmedConfirmPassword == "") {
    setCurrentError(t("changePassword.error.space"));
    return false;
  }

  if (trimmedNewPassword === "") {
    setNewError(t("changePassword.error.entern"));
    return false;
  }

  if (trimmedConfirmPassword === "") {
    setConfirmError(t("changePassword.error.enterc"));
    return false;
  }

  if (trimmedNewPassword.length < 6) {
    setNewError(t("changePassword.error.min6"));
    return false;
  }

  if (trimmedNewPassword !== trimmedConfirmPassword) {
    setConfirmError(t("changePassword.error.notmatch"));
    return false;
  }

  if (trimmedNewPassword.length > 16) {
    setNewError(t("changePassword.error.max16"));
    return false;
  }

  if (!validregex.test(trimmedNewPassword)) {
    setNewError(t("changePassword.error.blank"));
    return false;
  }

  return true;
};
